'use strict';
(() => {
    const productThumbnails = new Swiper('.product-image__thumbnails', {
      spaceBetween: 10,
      loop: false,
      freeMode: true,
      loopedSlides: 5, //looped slides should be the same
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slidesPerView: 'auto',
      breakpoints: { // >=750
        750: {
          loop: false,
          spaceBetween: 0,
          slidesPerView: 'auto',
          freeMode: false,
        }
      }
    });

    const productImageSlider = new Swiper('.product-image__slider', {
      spaceBetween: 0,
      loop: false,
      loopedSlides: 5, //looped slides should be the same
      autoHeight: true,
      breakpoints: { // >=750
        750: {
          loop: false,
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',

      },

      thumbs: {
        swiper: productThumbnails,
        autoScrollOffset: 0,
      },

    });
})();